import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles.css';
import { GoogleOAuthProvider } from '@react-oauth/google';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* Replace YOUR_GOOGLE_CLIENT_ID with the one you copied */}
    <GoogleOAuthProvider clientId="846852970696-adhsdfst3mq4328tqtt57ldi0t00i39i.apps.googleusercontent.com">
        <App />
    </GoogleOAuthProvider>
  </React.StrictMode>
);